import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';

import Home from './pages/Home';
import Alphabets from './pages/Alphabets';
import AlphabetDetail from './pages/AlphabetDetail';
import Numbers from './pages/Numbers';
import NumberDetail from './pages/NumberDetail';
import Colors from './pages/Colors';
import Words from './pages/Words';
import WordCategory from './pages/WordCategory';
import Rhymes from './pages/Rhymes';
import RhymeDetail from './pages/RhymeDetail';
import Stories from './pages/Stories';
import StoryDetail from './pages/StoryDetail';

function App() {
    return (
        <Router>
            <Switch>
                <Route exact path="/" component={Home} />

                <Route exact path="/alphabets" component={Alphabets} />
                <Route path="/alphabets/:letter" component={AlphabetDetail} />

                <Route exact path="/numbers" component={Numbers} />
                <Route path="/numbers/:number" component={NumberDetail} />

                <Route exact path="/colors" component={Colors} />

                <Route exact path="/words" component={Words} />
                <Route path="/words/:category" component={WordCategory} />

                <Route exact path="/rhymes" component={Rhymes} />
                <Route path="/rhymes/:id" component={RhymeDetail} />

                <Route exact path="/stories" component={Stories} />
                <Route path="/stories/:id" component={StoryDetail} />
            </Switch>
        </Router>
    );
}

export default App;
